<script setup>
import { ChevronDownIcon, ChevronUpIcon, Trash2Icon } from "lucide-vue-next";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import PreviewInput from "./PreviewInput.vue";
import PreviewTextarea from "./PreviewTextarea.vue";
import Badge from "@Components/Badge.vue";

const profile = defineModel("profile");

const props = defineProps({
    localProfiles: {
        type: Array,
        default: [],
    },
});

defineEmits(["deleteProfile"]);

const { t: __ } = useI18n();

const showDetails = ref(false);

const localProfile = computed(() => {
    let id = profile.value.id.replace("prf_", "");
    return props.localProfiles.find((localProfile) => {
        return localProfile.id === parseInt(id);
    });
});
</script>
<template>
    <div>
        <div class="flex items-center gap-1.5">
            <Badge v-if="profile.existing" class="flex-none text-xs">{{ __("Existant") }}</Badge>
            <Badge v-else class="flex-none text-xs">{{ __("Nouveau") }}</Badge>
            <div class="grid flex-1 grid-cols-6 gap-1.5">
                <div class="col-span-3">
                    <PreviewInput
                        type="text"
                        :placeholder="__('Prénom')"
                        :model-value="profile.existing ? localProfile?.user_first_name : profile.first_name"
                        @update:model-value="profile.first_name = $event"
                        :readonly="profile.existing" />
                </div>

                <div class="col-span-3">
                    <PreviewInput
                        type="text"
                        :placeholder="__('Nom')"
                        :model-value="profile.existing ? localProfile?.user_last_name : profile.last_name"
                        @update:model-value="profile.last_name = $event"
                        :readonly="profile.existing" />
                </div>
            </div>
            <Trash2Icon
                @click="$emit('deleteProfile')"
                class="size-4 flex-none text-gray-600 cursor-pointer dark:text-gray-400 dark:hover:text-white hover:text-gray-900" />
            <component
                :is="showDetails ? ChevronUpIcon : ChevronDownIcon"
                @click="showDetails = !showDetails"
                class="size-4 flex-none text-gray-600 cursor-pointer dark:text-gray-400 dark:hover:text-white hover:text-gray-900" />
        </div>

        <div v-if="showDetails" class="px-3 py-2">
            <div class="grid flex-1 grid-cols-6 gap-1.5">
                <div class="col-span-1">
                    <PreviewInput
                        type="number"
                        :placeholder="__('Âge')"
                        :model-value="profile.existing ? localProfile?.age : profile.age"
                        @update:model-value="profile.age = $event"
                        :readonly="profile.existing"
                        :min="18"
                        :max="99" />
                </div>
                <div class="col-span-5">
                    <PreviewInput
                        type="text"
                        :placeholder="__('Profession, passion ou loisir')"
                        :model-value="profile.existing ? localProfile?.job : profile.job"
                        @update:model-value="profile.job = $event"
                        :readonly="profile.existing" />
                </div>
                <div class="col-span-full">
                    <PreviewTextarea
                        :placeholder="__('Biographie')"
                        :rows="2"
                        :model-value="profile.existing ? localProfile?.user_description : profile.biography"
                        @update:model-value="profile.biography = $event"
                        :readonly="profile.existing" />
                </div>
            </div>
        </div>
    </div>
</template>
